// extracted by mini-css-extract-plugin
module.exports = {"container":"xseRaIyTJQZUSML8zF8j_","sidebarSmall":"XIi3ov-Y3AhFllZe1Ibhq","shadow":"_279cbJwhirSur_F7a5ES-7","flex":"_3edcFYIeWeLXotQc9fe_HW","sections":"_2oTg6Fw62W6UaZS7EsX6KP"};